/** Questions the worker's agent asked and where the household's agent found each answer, shown in the agents' talk. */
export const ask = {
    "ask.by_theirs": "asked by {name}'s agent",
    "ask.by_mine": "asked by your agent",
    "ask.standard": "standard question",
    "ask.from_memory": "from your past jobs",
    "ask.from_words": "from what you said",
    "ask.skip": "Skip",
    "ask.skipped": "Skipped",
    "ask.number": "A number",
    "ask.memory_offer": "From your past jobs: {value}. Send this?",
    "ask.memory_old": "I knew this a year ago: {value}. Still right?",
    "ask.change": "Change",
};
//# sourceMappingURL=ask.js.map